/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputFilePresign
 */
export interface OutputFilePresign {
    /**
     * 
     * @type {number}
     * @memberof OutputFilePresign
     */
    fileId: number;
    /**
     * 
     * @type {string}
     * @memberof OutputFilePresign
     */
    uploadUrl: string;
}

/**
 * Check if a given object implements the OutputFilePresign interface.
 */
export function instanceOfOutputFilePresign(value: object): boolean {
    if (!('fileId' in value)) return false;
    if (!('uploadUrl' in value)) return false;
    return true;
}

export function OutputFilePresignFromJSON(json: any): OutputFilePresign {
    return OutputFilePresignFromJSONTyped(json, false);
}

export function OutputFilePresignFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputFilePresign {
    if (json == null) {
        return json;
    }
    return {
        
        'fileId': json['fileId'],
        'uploadUrl': json['uploadUrl'],
    };
}

export function OutputFilePresignToJSON(value?: OutputFilePresign | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fileId': value['fileId'],
        'uploadUrl': value['uploadUrl'],
    };
}

